var map = {
	"./1spade-00.svg": "f1d1",
	"./1spade-01.svg": "8fad",
	"./1spade-02.svg": "b37b",
	"./1spade-03.svg": "b234",
	"./1spade-04.svg": "ddf8",
	"./1spade-05.svg": "ea56",
	"./1spade-06.svg": "d8be",
	"./1spade-07.svg": "a201",
	"./1spade-08.svg": "736c",
	"./1spade-09.svg": "afe6",
	"./1spade-10.svg": "6680",
	"./1spade-11.svg": "9849",
	"./1spade-12.svg": "e21e",
	"./1spade-13.svg": "ce71",
	"./2heart-00.svg": "9002",
	"./2heart-01.svg": "fb2d",
	"./2heart-02.svg": "509b",
	"./2heart-03.svg": "0cb2",
	"./2heart-04.svg": "123a",
	"./2heart-05.svg": "a7a9",
	"./2heart-06.svg": "49cb",
	"./2heart-07.svg": "938f",
	"./2heart-08.svg": "ae97",
	"./2heart-09.svg": "2089",
	"./2heart-10.svg": "9513",
	"./2heart-11.svg": "0b51",
	"./2heart-12.svg": "99ce",
	"./2heart-13.svg": "16dd",
	"./3diamond-00.svg": "de79",
	"./3diamond-01.svg": "9868",
	"./3diamond-02.svg": "9a88",
	"./3diamond-03.svg": "d976",
	"./3diamond-04.svg": "c92f",
	"./3diamond-05.svg": "ebc8",
	"./3diamond-06.svg": "a05e",
	"./3diamond-07.svg": "21d6",
	"./3diamond-08.svg": "aae9",
	"./3diamond-09.svg": "4c4c",
	"./3diamond-10.svg": "c0a6",
	"./3diamond-11.svg": "41c8",
	"./3diamond-12.svg": "aae0",
	"./3diamond-13.svg": "1931",
	"./4club-00.svg": "74c3",
	"./4club-01.svg": "dbc4",
	"./4club-02.svg": "f6a3",
	"./4club-03.svg": "ee33",
	"./4club-04.svg": "af9d",
	"./4club-05.svg": "bd27",
	"./4club-06.svg": "5e35",
	"./4club-07.svg": "f560",
	"./4club-08.svg": "6614",
	"./4club-09.svg": "feb6",
	"./4club-10.svg": "fc57",
	"./4club-11.svg": "3951",
	"./4club-12.svg": "eac2",
	"./4club-13.svg": "4782"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";